const sortMenuItems = (items) =>
  items.sort((first, second) => {
    if (first.order > second.order) return 1;
    if (first.order < second.order) return -1;

    return 0;
  });

export default sortMenuItems;
